/**
 * Onboarding V2 — icon name → component resolution.
 *
 * The option catalogs in `onboardingV2Model.ts` carry icon NAMES (plain
 * strings) so the model layer stays free of JSX and remains unit-testable in a
 * plain Node environment. This module is the single place that turns those
 * names into rendered lucide icons.
 *
 * An unknown name resolves to `HelpCircle` rather than rendering nothing —
 * a missing icon must never collapse a choice card's layout.
 */

import type { LucideIcon } from 'lucide-react';
import {
  BellRing,
  Bot,
  BriefcaseBusiness,
  Building2,
  CalendarClock,
  GraduationCap,
  HelpCircle,
  Instagram,
  Layers,
  Link2,
  Megaphone,
  MessageSquare,
  MessageSquareText,
  PhoneCall,
  Share2,
  Shirt,
  Sparkles,
  Stethoscope,
  Target,
  Unlink,
  Users,
  UtensilsCrossed,
  Zap,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  BellRing,
  Bot,
  BriefcaseBusiness,
  Building2,
  CalendarClock,
  GraduationCap,
  HelpCircle,
  Instagram,
  Layers,
  Link2,
  Megaphone,
  MessageSquare,
  MessageSquareText,
  PhoneCall,
  Share2,
  Shirt,
  Sparkles,
  Stethoscope,
  Target,
  Unlink,
  Users,
  UtensilsCrossed,
  Zap,
};

export function resolveOnboardingIcon(name?: string): LucideIcon {
  return (name && ICONS[name]) || HelpCircle;
}
